import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';

const CompanyActions = ({
  isOpen,
  onClickOpen,
  onClose,
  companyId,
  position,
}) => {
  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewCompany = <span className={className}>View Company Details</span>;
    const syncStripe = <span className={className}>Sync Stripe Account</span>;
    const stripeOnboarding = (
      <span className={className}>Go to Stripe Onboarding</span>
    );
    const stripeAccount = (
      <span className={className}>Go to Stripe Account Update</span>
    );

    let options = [syncStripe, stripeOnboarding, stripeAccount, viewCompany];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

CompanyActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  companyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
CompanyActions.defaultProps = {
  position: 'bottom',
  companyId: null,
};

export default memo(CompanyActions);
